import * as React from 'react'
import { useState,useEffect } from 'react'
import { connect } from 'react-redux'
import Modal from '../../common/modal'
import LineInput from '../../common/lineinput'
import { Stack, Box, FormControlLabel, Checkbox } from '@mui/material'
import Button from '@mui/material/Button'
import { addEWBDetails, EwayBillUpdate, resetEWBDetails, updateModal } from '../../../store/common/common_action'
import { navigation1, lineInputNavigation, focusElemnt, isNull, navigation2 } from '../../common/helper'
import * as iid from '../../common/bookingElementId'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { getEwaybillData, removeEWaybill, updateAlert } from '../../../store/common/common_action'
import * as error from '../../common/error_strings'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { Item } from '../../common/snippets'
import Datepicker from '../../common/datePicker'
import { GetRequest } from '../../common/api'
import { urls } from '../../common/constants'
import moment from 'moment'
import DropDownOA from '../../common/dropDownOA'

const EwayBillTab = (props) => {
  const { getEwaybillData, removeEWaybill, data, EwayBillUpdate } = { ...props }
  const { common } = data
  const { addEWBDetails, resetEWBDetails, updateModal } = props
  const { selectLr = {} } = props
  let { ewayBillDetailsList, ewayBillAuthDetails, loginData } = common
  if (!ewayBillDetailsList) ewayBillDetailsList = []
  const { ewayBillExemptedItems = [] } = common
  const {
    companySettings: [companySettings]
  } = common
  const { IsEwayBillValidate = 0 } = companySettings || {}
  const [ewayBillNo, setEwayBillNo] = useState()
  const [selectWayBillList, setSelectWayBillList] = useState([])
  const [ewayBillNoList, setEwayBillNoList] = useState([])
  const [serverDate, setServerDate] = useState()
  const [strtDate, setStrtDate] = useState()
  const [endDate, setEndDate] = useState()
  const [isExmpted, setIsExempted] = useState(false)
  const [exemptedReason, setExemptedReason] = useState('')

  React.useEffect(() => {
    GetRequest(urls.getServerTime).then((res) => {
      let temp = res?.split(' ', 1)
      const serDate = temp[0]
      setServerDate(serDate)

      const sDate = new Date(temp[0])
      sDate?.setMonth(sDate?.getMonth() - 6)
      setStrtDate(moment(new Date(sDate)).format('DD-MMM-YYYY'))

      const eDate = new Date(temp[0])
      eDate?.setMonth(eDate?.getMonth() + 6)
      setEndDate(moment(new Date(eDate)).format('DD-MMM-YYYY'))
      // console.log('ServerDate', serDate)
      // console.log(moment(new Date(sDate)).format('DD-MMM-YYYY'))
      // console.log(moment(new Date(eDate)).format('DD-MMM-YYYY'))
    })
  }, [])
  useEffect(() => {
    const { EWayBillNo, ExemptedValueID, IsExemptedValue } = selectLr || {}
    if (IsExemptedValue && ExemptedValueID) {
      setIsExempted(true)
      setExemptedReason(ewayBillExemptedItems.find((a) => a.ID === ExemptedValueID) || '')
      focusElemnt('exempted-dropdown')
    }
    if (EWayBillNo) {
      const ewblist = EWayBillNo.split(',')
      ewblist.map((ewabill)=>{
        addEWBDetails({ EWBNo: ewabill })
      })
      let a=EWayBillNo.split('~', 2)
      setEndDate(a[0])
    }      
  }, [selectLr])

  React.useEffect(() => {
    const tempEWBList = []
    ewayBillDetailsList.map((item, index) => {
      if (!tempEWBList.includes(item.EWBNo)) {
        tempEWBList.push(item.EWBNo)
      }
    })
    setEwayBillNoList(tempEWBList)
  }, [ewayBillDetailsList])
  const handleChange = (e) => {
    const waybillNumber = e.target.value.replace(/\D/g, '')
    if (waybillNumber.length <= 12) {
      setEwayBillNo(waybillNumber)
    }
  }
  const handleChecked = (ewaybil, toRemove) => {
    if (toRemove) {
      setSelectWayBillList((oldList) => [...oldList, ewaybil])
    } else {
      setSelectWayBillList(selectWayBillList.filter((ewb) => ewb != ewaybil))
    }
  }
  const handleAlert = (msg = false, nextId = '') => {
    if (typeof msg === 'string' && !isNull(msg)) {
      props.updateAlert({ show: true, msg, nextId })
    } else {
      props.updateAlert({ show: false, msg: '', nextId: '' })
      focusElemnt(nextId)
    }
  }
  const handleEwayBillAdd = () => {
    if (ewayBillNo.length == 12 && !ewayBillNoList.includes(ewayBillNo)) {
      setEwayBillNo('')
      if (IsEwayBillValidate) {
        getEwaybillData(loginData, ewayBillNo, ewayBillAuthDetails)
      } else {
        addEWBDetails({ EWBNo: ewayBillNo })
      }
    } else {
      //  console.log(error.EWAY_BILL)
      handleAlert(error.EWAY_BILL, iid.ewaybillNoInput)
    }
  }
  const handleEwayBillRemove = () => {
    selectWayBillList.map((selectedEWB) => {
      setEwayBillNoList(ewayBillNoList.filter((ewaybil) => ewaybil != selectedEWB))
      removeEWaybill(selectedEWB)
    })
    setSelectWayBillList([])
  }
  const handleEwayBillUpdate = () => {
    var allEWayBill = ewayBillDetailsList.map((el) => el.EWBNo).join(',')
    const data = {
      CompanyID: loginData.intCompanyID,
      UserID: loginData.intUserID,
      BookingID: selectLr?.BookingID || 0,
      EwayBillno: isExmpted ? '' : allEWayBill + '~' + endDate,
      IsExempted: isExmpted ? 1 : 0,
      ExemptedGoodsID: exemptedReason?.ID || 0,
    }
    EwayBillUpdate(data, props.setOnClosePopup)
  }
  const handleExcmptCheckUnCheck = () => {
    if (isExmpted) {
      setIsExempted(false)
      setExemptedReason('')
    } else {
      setIsExempted(true)
    }
  }
  const handleSaveExemptedReason = (e) => {
    const {
      target: { id },
    } = e
    if (id === 'exempted-save') {
      if (exemptedReason) {
        updateModal()
        handleEwayBillUpdate()
        focusElemnt(iid.eWayBillNo)
      } else {
        handleAlert('Please Select Type of Exempted Itme', 'exempted-dropdown')
      }
    } else {
      updateModal()
      focusElemnt(iid.eWayBillNo)
      setIsExempted(false)
      setExemptedReason('')
    }
  }
  const cancelClose = () => {
    updateModal()
    setEwayBillNoList([])
    resetEWBDetails()
  }
  return (
    <>
      <Stack direction="column" sx={{ padding: '15px 0px', fontSize: '15px' }}>
        <div style={{ width: '100%', padding: '0px 15px', position: 'relative' }}>
          <div
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                width: '99%',
                display: 'inline-flex',
                padding: '0% 0px',
              }}
            >
              <div className={'input--wrapper small_space'}>
                <LineInput
                  id={iid.ewaybillNoInput}
                  type={`text`}
                  name={`ewaybillNo`}
                  label={`Enter E-way Bill`}
                  value={ewayBillNo}
                  autoFocus={true}
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  disabled={isExmpted}
                  onKeyDown={(e) => navigation1(e, iid.ewayBillFetch, iid.closeButton)}
                />
              </div>

              <div className="input--wrapper small_space">
                <Button
                  id={iid.ewayBillFetch}
                  className="btn add-btn"
                  variant="contained"
                  color="error"
                  onClick={handleEwayBillAdd}
                  disabled={isExmpted}
                  onKeyDown={(e) =>
                    navigation2(e, selectWayBillList.length ? 'removeewaybillButton' : 'exempted-checkbox', iid.ewaybillNoInput)
                  }
                >
                  Add
                </Button>
                {selectWayBillList.length > 0 && (
                  <Button
                    sx={{ marginRight: '10px' }}
                    className="btn cancel-btn"
                    variant="outlined"
                    color="error"
                    onClick={() => handleEwayBillRemove()}
                  >
                    Remove
                  </Button>
                )}
              </div>
              <div className="input--wrapper small_space">
                <FormControlLabel
                  control={
                    <Checkbox
                      id="exempted-checkbox"
                      checked={isExmpted}
                      onChange={handleExcmptCheckUnCheck}
                      disabled={ewayBillNoList.length}
                      onKeyDown={(e) =>
                        navigation2(
                          e,
                          isExmpted ? 'exempted-dropdown' : '',
                          selectWayBillList.length ? 'removeewaybillButton' : iid.ewayBillFetch
                        )
                      }
                    />
                  }
                  label="Is Exempted Item ?"
                />
              </div>
              {isExmpted ? (
                <>
                  <div className="input--wrapper flexgrow">
                    <DropDownOA
                      label="Select Exempted Item"
                      id="exempted-dropdown"
                      data={ewayBillExemptedItems}
                      dataKey={'GoodsDesc'}
                      idKey="ID"
                      value={exemptedReason?.GoodsDesc || ''}
                      defaultvalue={exemptedReason?.GoodsDesc || ''}
                      onSelect={(reason) => setExemptedReason(reason)}
                      onReset={() => setExemptedReason('')}
                      nextId="exempted-save"
                      prevId="exempted-checkbox"
                    />
                  </div>
                  <div className="input--wrapper small_space">
                    <Button
                      id={'exempted-save'}
                      className="btn add-btn"
                      variant="contained"
                      color="error"
                      onClick={handleSaveExemptedReason}
                      onKeyDown={(e) => navigation1(e, 'exempted-cancel', 'exempted-dropdown')}
                    >
                      Save
                    </Button>
                    <Button
                      id="exempted-cancel"
                      className="btn cancel-btn"
                      variant="outlined"
                      color="error"
                      onClick={handleSaveExemptedReason}
                      onKeyDown={(e) => navigation1(e, '', 'exempted-save')}
                    >
                      Cancel
                    </Button>
                  </div>
                </>
              ) : (
                ''
              )}
            </Box>
          </div>
        </div>
      </Stack>
      {ewayBillDetailsList.length > 0 && (
        <Stack>
          <TableContainer className="lr-popup-table lrModel" component={Paper}>
            <Table style={{ minWidth: 650 }} size="medium" sx={{ fontSize: '15px' }} aria-label="a dense table">
              <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                <TableRow className="eway-bill-table-row">
                  <TableCell>Select</TableCell>
                  <TableCell>E-WayBill No.</TableCell>
                  <TableCell>Transporter</TableCell>
                  <TableCell>Sender</TableCell>
                  <TableCell>Receiver</TableCell>
                  <TableCell>Sender GSTN</TableCell>
                  <TableCell>Receiver GSTN</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="filter-data-row">
                {ewayBillDetailsList?.map((item, index, list) => (
                  <TableRow key={index} className="eway-bill-table-row">
                    <TableCell>
                      <input
                        type="checkbox"
                        className="tableCheckbox"
                        id={iid.checkboxWbList + index}
                        onChange={(e) => handleChecked(item.EWBNo, e.target.checked)}
                        name="record"
                        onKeyDown={(e) => {
                          lineInputNavigation(
                            e,
                            index === list.length - 1 ? iid.cancelEwayBilPage : iid.checkboxWbList + (index + 1),
                            index === 0 ? iid.ewayBillFetch : iid.checkboxWbList + (index - 1)
                          )
                        }}
                      />
                    </TableCell>
                    <TableCell>{item.EWBNo}</TableCell>
                    <TableCell>{item.TransporterName}</TableCell>
                    <TableCell>{item.FromTrdName}</TableCell>
                    <TableCell>{item.ToTrdName}</TableCell>
                    <TableCell>{item.FromGstin}</TableCell>
                    <TableCell>{item.ToGstin}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      )}
      {ewayBillDetailsList.length > 0 && (
        <Stack>
          <div className="modal-btn-grp">
            <Button
              id={iid.cancelEwayBilPage}
              className="btn cancel-btn"
              variant="outlined"
              color="error"
              onClick={() => {
                focusElemnt(iid.eWayBillNo)
                cancelClose()
              }}
            >
              Cancel
            </Button>
            <Button
              id={iid.saveEwayBillPage}
              className="btn add-btn"
              variant="contained"
              color="error"
              onClick={() => {
                handleEwayBillUpdate()
                focusElemnt(iid.eWayBillNo)
                props.updateModal()
              }}
            >
              Update
            </Button>
          </div>
        </Stack>
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { updateModal, removeEWaybill, getEwaybillData, updateAlert, EwayBillUpdate, addEWBDetails, resetEWBDetails }
export default connect(mapStateToProps, mapDispatchToProps)(EwayBillTab)
